"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GlobalMarkets() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const divisions = [{
    image: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/home_loan_service.webp?v=obd8nkzhl9s",
    srcset: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/home_loan_service.webp?v=swtk1l1wy1f-wvc-srcset",
    sizes: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/home_loan_service.webp?v=9yvj24p6sxb-wvc-sizes",
    title: "Home Loan Appointment",
    description: "Navigate the property market with confidence. We provide tailored mortgage solutions and expert guidance to help you secure your dream home with competitive rates and flexible terms."
  }, {
    image: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/business_loan_service.webp?v=291qcu6wfi4",
    srcset: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/business_loan_service.webp?v=9rpof4658s9-wvc-srcset",
    sizes: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/business_loan_service.webp?v=idtwghb2w7-wvc-sizes",
    title: "Business Loan Appointment",
    description: "Empower your business with strategic funding. From equipment finance to large-scale commercial acquisitions, we match your goals with the right lenders for sustainable growth."
  }, {
    image: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/car_dealership_showroom.png?v=5lqjpe7ou4r",
    srcset: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/car_dealership_showroom.png?v=3oyqp71f8yu-wvc-srcset",
    sizes: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/car_dealership_showroom.png?v=s2pho9drzs-wvc-sizes",
    title: "Car & Equipment Finance",
    description: "Get on the road or upgrade your operations with ease. We offer flexible financing options for vehicles and specialized machinery tailored to your cash flow requirements."
  }, {
    image: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/general_enquiry_service.webp?v=nrm0yccn2h",
    srcset: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/general_enquiry_service.webp?v=v7dbxfc9p8b-wvc-srcset",
    sizes: "https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/general_enquiry_service.webp?v=544t46i8awg-wvc-sizes",
    title: "General Enquiries",
    description: "Not sure where to start? Our expert team is here to discuss your unique financial situation and guide you toward the right lending pathway for your future success."
  }];
  return <section data-section-id="231155" id="expertiseacrossmarkets" className="bg-background py-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        
        <div ref={headingRef} className={`text-center mb-20 transition-all duration-700 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight" style={{
          color: "var(--foreground)"
        }}>
            Expertise Across Markets
          </h2>
          <div className="mt-6 mx-auto w-24 h-0.5" style={{
          backgroundColor: "var(--primary)"
        }} />
          <p className="mt-6 text-lg md:text-xl max-w-2xl mx-auto font-default leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>
            SLA Finance Group delivers premium brokerage services across diverse financial sectors, ensuring your capital works harder for you.
          </p>
        </div>

        
        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-700 ease-out delay-200 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {divisions.map((division, i) => <div data-index={i} key={i} className="rounded-lg border flex flex-col items-center text-center group hover:shadow-xl hover:-translate-y-2 transition-all duration-300 h-full overflow-hidden" style={{
          backgroundColor: "var(--card)",
          borderColor: "var(--border)"
        }}>
              <img src={division.image} data-wvc-srcset={division.srcset} data-wvc-sizes={division.sizes} alt={division.title} className="w-full h-48 object-cover rounded-t-lg" loading="lazy" />

              <div className="px-6 pb-12 pt-8 flex flex-col items-center">
                <h3 className="font-default text-xl md:text-2xl font-bold mb-4 tracking-tight" style={{
              color: "var(--foreground)"
            }}>
                  {division.title}
                </h3>

                <div className="w-12 h-0.5 mb-6" style={{
              backgroundColor: "var(--primary)"
            }} />

                <p className="font-default text-sm md:text-base leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                  {division.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}